import { useEffect } from 'react';

const Adminpanel = () => {
  useEffect(() => {
    // Redirect to the desired page
    window.location.href = 'https://partners.fusionepos.co.uk/';
  }, []);

  return null; // This component doesn't render anything visible to the user
};

export default Adminpanel;
